import { useGetInvoiceTransaction } from '@/context/services/reportsType/invoiceReports/Edit.service';
import { useMemo } from 'react';

export const useInvoicesTransaction = (reportId: string) => {
  const data = useGetInvoiceTransaction(reportId);
  /** mapping data to table props in case of id is not exist */
  const items = useMemo(() => {
    return (data || []).map((item, index) => ({
      ...item,
      id: item.id || `${reportId}-${index}`,
    }));
  }, [data, reportId]);

  return {
    data: items,
  };
};

export const useDefaultPagination = () => {
  return useMemo(
    () => ({
      currentPage: 1,
      maxPage: 1,
      perPage: 1,
      maxRecord: 0,
    }),
    []
  );
};
